import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const RETURN_SIGN_HELP: HelpContent[] = [
    {
        helpContentId: 'return-sign.skip-button',
        tooltipText: 'Skip applying digital signatures.'
    }
];
